/* import __COLOCATED_TEMPLATE__ from './split-segments.hbs'; */
var _dec, _class;
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

/*
 * This component is internal to the `t-split` component. Refer to it for documentation.
 */
let TSplit = (_dec = tagName(''), _dec(_class = class TSplit extends Component {}) || _class);
export { TSplit as default };